"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../style/variables");
var Text_1 = __importDefault(require("../../Text"));
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var Popover_1 = __importDefault(require("./Popover"));
var TimePicker_1 = require("./TimePicker");
var utils_1 = require("./utils");
var styles = {
    textContainer: react_1.css({
        flex: 1,
        border: 'none',
        outline: 'none',
        background: 'transparent',
        margin: 0,
        padding: 0,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        transition: 'background-color 0.3s ease',
        '.focus-line': {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 0,
            transition: 'border-color 0.3s ease',
            borderBottom: '1px solid transparent',
            pointerEvents: 'none',
        },
        ':focus-visible': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_4 + ")",
        },
    }),
    rangeTextContainer: react_1.css({
        ':focus': {
            '.focus-line': {
                borderColor: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
            },
        },
        ':focus-visible': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_4 + ")",
            '.focus-line': {
                borderColor: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
            },
        },
    }),
};
var Picker = function (_a) {
    var size = _a.size, time = _a.time, placeholder = _a.placeholder, use12Hours = _a.use12Hours, onChange = _a.onChange, range = _a.range, disabled = _a.disabled;
    var _b = react_2.useState(false), visible = _b[0], setVisible = _b[1];
    var text = react_2.useMemo(function () { return time && utils_1.getTimeString(time, use12Hours); }, [time, use12Hours]);
    var handleOnChange = function (nextTime) {
        onChange(nextTime);
        setVisible(false);
    };
    var textColor = disabled ? variables_1.ComponentColor.Form.Text.DISABLED : variables_1.ComponentColor.Form.Text.FILLED;
    return (react_1.jsx(Tooltip_1.default, { visible: !disabled && visible, onVisibleChange: setVisible, trigger: ['click'], placement: "bottom", destroyTooltipOnHide: true, overlayInnerStyle: { boxShadow: 'none', border: 'none', margin: 0, padding: 0 }, prefixCls: "sixsense-time-picker-popover", showArrow: false, overlay: function () { return (react_1.jsx(Popover_1.default, { onRequestClose: handleOnChange, time: time || TimePicker_1.DEFAULT_TIME, use12Hours: use12Hours })); } },
        react_1.jsx("button", { disabled: disabled, css: [
                styles.textContainer,
                range ? styles.rangeTextContainer : undefined,
            ] },
            react_1.jsx(Text_1.default.Body, { size: size === 'sm' ? 'sm' : 'default', color: "var(" + (text ? textColor : variables_1.ComponentColor.Form.Text.PLACEHOLDER) + ")" }, text || placeholder),
            react_1.jsx("div", { className: "focus-line" }))));
};
exports.default = Picker;
